import { render, staticRenderFns } from "./TransactionsCard.vue?vue&type=template&id=84bf606e&"
import script from "./TransactionsCard.vue?vue&type=script&lang=js&"
export * from "./TransactionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports